import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useGigyaStore } from '../store/use-gigya-store';
export const GigyaProvider = ({ children }) => {
    const { loadGigya } = useGigyaStore();
    useEffect(() => {
        loadGigya();
    }, [loadGigya]);
    return _jsx(_Fragment, { children: children });
};
//# sourceMappingURL=use-gigya-provider.js.map